"use strict";

module.exports = function (data) {

    this.count = data.length;

    return data;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/filters/set-count.js